import React, { Component } from "react";
import footerC from "../../../media/images/footerC.png";
import footerL from "../../../media/images/footerL.png";

import { LinkedinIcon, FacebookIcon, TwitterIcon } from "react-share";
const footer = [footerC, footerL][Math.floor(Math.random() * 2)];

export class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <img
          className={`responsive-img ${
            window.location.pathname === "/" ? "grey lighten-2" : ""
          }`}
          src={footer}
          alt="JetMinds Footer"
          loading="lazy"
          style={{ width: "100%" }}
        />
        <footer className="page-footer orange darken-4">
          <div className="container">
            <div className="row">
              <div className="col l6 s12">
                <h5 className="black-text">
                  <b>JetMinds</b>
                </h5>
                <p className="black-text">
                  Dienstleister für moderne Informationstechnologien und
                  digitale Transformation. Schleswig-Holstein - Hamburg
                </p>
              </div>
              <div className="col l3 s12">
                <h5 className="black-text">Links</h5>
                <ul>
                  <li>
                    <a className="white-text" href="/impressum">
                      Impressum
                    </a>
                  </li>
                  <li>
                    <a className="white-text" href="/datenschutzerklaerung">
                      Datenschutz
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col l3 s12">
                <h5 className="black-text">Kontakt</h5>
                <ul>
                  <li>
                    <a className="white-text" href="/kontakt">
                      Kontaktformular
                    </a>
                  </li>
                  <li>
                    <a className="white-text" href="mailto:info@jetminds.de">
                      info@jetminds.de
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <a
                  className="btn-floating scale-transition z-depth-3 white"
                  href="https://de.linkedin.com/company/jetminds-de"
                  target="_blanck"
                >
                  <LinkedinIcon size={40} round={true} />
                  LinkedIn
                </a>
              </div>
              <div className="col">
                <a
                  className="btn-floating scale-transition z-depth-3 white"
                  href="https://twitter.com/jetminds_de"
                  target="_blanck"
                >
                  <TwitterIcon size={40} round={true} />
                  Twitter
                </a>
              </div>
              <div className="col">
                <a
                  className="btn-floating scale-transition z-depth-3 white"
                  href="https://www.facebook.com/jetminds.de"
                  target="_blanck"
                >
                  <FacebookIcon size={40} round={true} />
                  Facebook
                </a>
              </div>
            </div>
          </div>

          <div className="footer-copyright grey darken-3">
            <div className="container white-text">© JetMinds</div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/layout/navigation/Footer.js